export const setTrendTopicsQuestions = (state, payload) => { 
    return {
        ...state,
        selectedTopics: payload.topics,
        selectedQuestions: payload.questions
    };
};